export const COLORS = {
  default0: {
    darker: "#0D4074",
    normal: "#01689B",
    lighter: "#CCE0F1",
  },
  default1: {
    darker: "#a53d09",
    normal: "#EF5D12",
    lighter: "#f99f72",
  },
  default: {
    darker: "#0D4074",
    normal: "#01689B",
    lighter: "#CCE0F1",
  },
  max: {
    darker: "#8A1500",
    normal: "#CE1F00",
    lighter: "#FFAC9D",
  },
};
